import { queryOptions } from '@tanstack/react-query';
import type { SectionDto } from '@atnt/shared';
import { api } from '@/shared/api/client';

/** Sections of a tenant (constructor group of the sidebar). Same key/shape as the constructor feature uses. */
export const sectionsQuery = (tenantId: string) =>
  queryOptions({
    queryKey: ['tenant', tenantId, 'sections'],
    queryFn: () => api.get<SectionDto[]>(`/tenants/${tenantId}/sections`),
    staleTime: 60_000,
  });
